import { listenEvent } from "./vidstack-D9mvYVIz.js";
//#region src/providers/google-cast/utils.ts
function getCastFrameworkURL() {
	return "https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1";
}
/**
* Whether the Google Cast framework has loaded.
*/
function hasLoadedCastFramework() {
	return !!window.cast?.framework;
}
/**
* Whether Google Cast is available on this platform.
*/
function isCastAvailable() {
	return !!window.chrome?.cast?.isAvailable;
}
/**
* Whether the cast sender is connected.
*/
function isCastConnected() {
	return getCastContext().getCastState() === cast.framework.CastState.CONNECTED;
}
/**
* @see {@link https://developers.google.com/cast/docs/reference/web_sender/cast.framework.CastContext}
*/
function getCastContext() {
	return window.cast.framework.CastContext.getInstance();
}
/**
* @see {@link https://developers.google.com/cast/docs/reference/web_sender/cast.framework.CastSession}
*/
function getCastSession() {
	return getCastContext().getCurrentSession();
}
/**
* @see {@link https://developers.google.com/cast/docs/reference/web_sender/chrome.cast.media.Media}
*/
function getCastSessionMedia() {
	return getCastSession()?.getSessionObj().media[0];
}
function hasActiveCastSession(src) {
	return getCastSessionMedia()?.media.contentId === src?.src;
}
/**
* @see {@link https://developers.google.com/cast/docs/reference/web_sender/cast.framework.CastOptions}
*/
function getDefaultCastOptions() {
	return {
		language: "en-US",
		autoJoinPolicy: chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED,
		receiverApplicationId: chrome.cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID,
		resumeSavedSession: true,
		androidReceiverCompatible: true
	};
}
function getCastErrorMessage(code) {
	return `Google Cast Error Code: ${code}`;
}
function listenCastContextEvent(type, handler) {
	return listenEvent(getCastContext(), type, handler);
}
//#endregion
export { getCastContext, getCastErrorMessage, getCastFrameworkURL, getCastSession, getCastSessionMedia, getDefaultCastOptions, hasActiveCastSession, hasLoadedCastFramework, isCastAvailable, isCastConnected, listenCastContextEvent };
